var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-select',{staticClass:"select-x",staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"id":"program-studi","options":_vm.items,"label":"label","placeholder":"Pilih Program Studi"},on:{"search":_vm.getOptions,"input":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }